import { native } from '@forest/native-services'

/** The page's X: closes the page unless `onClose` takes over. */
export function CloseButton(props: { onClose?: () => void }) {
  return (
    // TODO(i18n): resubscribe_close_label
    <button
      type="button"
      aria-label="Close"
      // Figma fills it white at 56% under a #2c2c2c color-dodge layer, which
      // divides by 0.8275 whatever is behind: 67.7% white over a 1.646×
      // brightened backdrop is the same arithmetic without a blend mode.
      class="gradient-stroke gradient-stroke-glass-edge fixed right-4 top-[calc(1px+var(--safe-area-top))] z-40 flex h-9 w-[37px] items-center justify-center rounded-3xl bg-white/[0.677] backdrop-blur-[37.5px] backdrop-brightness-[1.646] [--stroke-width:1.5px] active:opacity-80"
      onClick={() =>
        props.onClose ? props.onClose() : void native.general.close()
      }
    >
      <svg
        width="17.1429"
        height="17.1429"
        viewBox="0 0 17.1429 17.1429"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
      >
        <path
          d="M4.28575 4.28582L12.8571 12.8572"
          stroke="#333333"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4.2857 12.8572L12.8571 4.28582"
          stroke="#333333"
          stroke-width="1.3"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </button>
  )
}
